import styled from 'styled-components';
import imageSources from './constants/imageSources/imageSources';

export const ErrorPageDiv = styled.div`
    width: 100%;
    color: ${({ theme }) => theme.colors.neutral700};
    text-align: center;
`;

export const ErrorImage = styled.img`
    height: 400px;
    margin: 0px auto;
    display: block;
`;
export const ErrorParagraph = styled.p`
    text-align: center;
    font-size: 22px;
    line-height: 32px;
    margin-bottom: 10px;
`;
export const ErrorContactUsParagraph = styled.p`
    height: 48px;
    min-width: 187px;
    max-width: 187px;
    text-align: center;
    margin: 0 auto;
    font-size: 15px;
    color: ${({ theme }) => theme.colors.neutral700};
    line-height: 24px;
`;
export const BrowserSmallDiv = styled.div`
    height: 100vh;
    background-image: url("${imageSources.BROWSER_HEIGHT_SMALL}");
    background-size: cover;
`;
export const BrowserSmallTextDiv = styled.div`
    position: fixed;
    width: 350px;
    height: 200px;
    top: calc(50% - 100px);
    left: calc(50% - 175px);
    margin-bottom: 20px;
    color: ${({ theme }) => theme.colors.neutral700};
    text-align: center;
`;
export const TopText = styled.p`
    font-size: 21px;
    height: 32px;
`;
export const BottomText = styled.p`
    font-size:14px;
    height: 48px;
    text-align: center;
`;
export const FrameImageDiv = styled.div`
    position: fixed;
    width: 100%;
    bottom: 0;
    left: calc(50% - 100px);
`;
export const FrameImage = styled.img`
    width: 205px;
    height: 205px;
`;
